import { useEffect, useState } from 'react'
import { useParams } from '../Providers/ParamsProvider'
import LoadingSpinner from './Components/LoadingSpinner'
import { Licenses } from '../Data/Licenses.ts'

const MainThemeStylePicker = () => {
    const { license, handleGetLicense } = useParams()
    const [appVersion, setAppVersion] = useState(null)

    useEffect(() => {
        handleGetLicense()
        fetchVersion()
    }, [])

    useEffect(() => {
        if (!license || !appVersion) return

        let styleName = ''
        switch (license) {
            case Licenses.Ferrodo:
                styleName = 'FerrodoMainStyle.css'
                break
            case Licenses.TgInstalacje:
                styleName = 'TgMainStyle.css'
                break
            case Licenses.Hydraulik:
                styleName = 'HydraulikMainStyle.css'
                break
            case Licenses.Carmen:
                styleName = 'CarmenmainStyle.css'
                break
            default:
                styleName = 'FerrodoMainStyle.css'
        }

        const link = document.createElement('link')
        link.rel = 'stylesheet'
        link.type = 'text/css'
        link.href = `${process.env.PUBLIC_URL}/MainStyles/${styleName}?v=${appVersion}` //DK : dodajemu nr wersji aby zawsze po podbicu wersji pobierał nowy plik ze stylami!
        document.head.appendChild(link)

        return () => {
            document.head.removeChild(link)
        }
    }, [license, appVersion])

    const fetchVersion = async () => {
        try {
            const response = await fetch('/version.json', { cache: 'no-cache' })
            const data = await response.json()
            setAppVersion(data.version)
        } catch {
            setAppVersion('1')
        }
    }

    if (!license || license.trim() === '') {
        return (
            <div style={{
                position: "fixed",
                top: 0, left: 0,
                width: "100vw", height: "100vh",
                zIndex: 9999,
                backgroundColor: 'white'
            }}>
                <LoadingSpinner fullScreenLoading={true} loadingText='Ładowanie motywu aplikacji...' />
            </div>
        )
    }
}

export default MainThemeStylePicker